import { render, staticRenderFns } from "./image_upload_article_image.vue?vue&type=template&id=6b16177b&scoped=true&lang=pug"
import script from "./image_upload_article_image.vue?vue&type=script&lang=js"
export * from "./image_upload_article_image.vue?vue&type=script&lang=js"
import style0 from "./image_upload_article_image.vue.css?vue&type=style&index=0&id=6b16177b&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b16177b",
  null
  
)

export default component.exports